import router from './router'
import './router-guards'

export default router;